__turbopack_context__.v({
  "replacementsContainer": "SCjyta_replacementsContainer",
});
